import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const HOUSE_NUMBER_PATTERN = /^\d+(?:\s?[A-Za-z]|\/\d+)?$/;

export function houseNumberValidator(maxLength = 5): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const value = String(control.value).trim();

    if (value.length > maxLength) {
      return {
        maxlength: {
          requiredLength: maxLength,
          actualLength: value.length,
        },
      };
    }

    const isValid = HOUSE_NUMBER_PATTERN.test(value);

    return isValid ? null : { invalidHouseNumber: { value: control.value } };
  };
}
